import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { FullPageAppTemplate } from '../../templates'
import styles from './ByteBuilderApp.module.scss'

const ByteBuilderApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    const appProps = {
      user,
      initialPath: location.pathname,
      appPath: apps[AppId.BYTE_BUILDER].path,
      history,
      onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
        const { pathname } = location

        if (pathname !== nextPathname) {
          navigate(nextPathname)
        }
      }
    }

    return (
      <FullPageAppTemplate
        appId={AppId.BYTE_BUILDER}
        scope='byte_builder'
        envKey={apps[AppId.BYTE_BUILDER].runtimeEnvKey}
        entryPath='./ByteBuilderApp'
        url={process.env.REACT_APP_BYTE_BUILDER_APP_DEV_PATH}
        appName={apps[AppId.BYTE_BUILDER].name}
        appProps={appProps}
        className={styles.wrapper}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { ByteBuilderApp }
